import(/* webpackMode: "eager", webpackExports: ["JournalGrid"] */ "/app/new-design/pale-blue-dot-redesign/src/components/journal/JournalGrid.tsx");
